import { getToken } from "@chakra-ui/react";
import { orient } from "@chakra-ui/theme-tools";

function thumbOrientation(props) {
  return orient({
    orientation: props.orientation,
    vertical: {
      left: "50%",
      transform: `translateX(-50%)`,
      _active: {
        transform: `translateX(-50%) scale(1.15)`
      }
    },
    horizontal: {
      top: "50%",
      transform: `translateY(-50%)`,
      _active: {
        transform: `translateY(-50%) scale(1.15)`
      }
    }
  });
}

const baseStyleContainer = (props) => {
  const { orientation } = props;
  return {
    display: "inline-block",
    position: "relative",
    cursor: "pointer",
    _disabled: {
      opacity: 0.6,
      cursor: "default",
      pointerEvents: "none"
    },
    ...orient({
      orientation,
      vertical: { h: "100%" },
      horizontal: { w: "100%" }
    })
  };
};

const baseStyleTrack = {
  overflow: "hidden",
  borderRadius: "3px",
  bg: "lowEmphasis",
  _disabled: {
    opacity: 0.6
  }
};

const baseStyleThumb = (props) => {
  const primary = getToken("colors", "primary")(props.theme);
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    outline: 0,
    zIndex: 1,
    borderRadius: "100%",
    bg: "white",
    boxShadow:
      "0 3px 1px 0 rgba(0, 0, 0, 0.1), 0 1px 1px 0 rgba(0, 0, 0, 0.16), 0 3px 8px 0 rgba(0, 0, 0, 0.15)",
    border: "1px solid",
    borderColor: "transparent",
    transitionProperty: "transform",
    transitionDuration: "normal",
    _disabled: { opacity: 0.6 },
    _focusVisible: {
      boxShadow: `0 3px 1px 0 rgba(0, 0, 0, 0.1), 0 1px 1px 0 rgba(0, 0, 0, 0.16), 0 3px 8px 0 ${primary}`
    },
    ...thumbOrientation(props)
  };
};

const baseStyleFilledTrack = {
  width: "inherit",
  height: "inherit",
  bg: "primary"
};

const baseStyle = (props) => ({
  container: baseStyleContainer(props),
  track: baseStyleTrack,
  thumb: baseStyleThumb(props),
  filledTrack: baseStyleFilledTrack
});

const sizeMd = (props) => {
  return {
    thumb: { w: "14px", h: "14px" },
    track: orient({
      orientation: props.orientation,
      horizontal: { h: "2px" },
      vertical: { w: "2px" }
    })
  };
};

const sizes = {
  md: sizeMd
};

const defaultProps = {
  size: "md"
};

export default {
  sizes,
  baseStyle,
  defaultProps
};
